module.exports = __webpack_public_path__ + "img/4.316a2a6b.webp";